<template>
    <component
        v-if="value || value === 0"
        :is="isOld ? 's' : tag"
        class="l-ss-c-price"
        :class="{ 'l-ss-c-price-old': isOld }">
        {{ format(value) }}
        <i
            v-if="useCurrencyIcon"
            v-html="currencyIcon"
            class="l-ss-c-icon l-ss-c-price-icon"></i>
    </component>
</template>

<script>
    import { currencyAsString, getCurrencyIcon } from '@/core/helpers/display';

    export default {
        props: {
            tag: {
                type: String,
                default: 'strong',
            },
            isOld: {
                type: Boolean,
                default: false,
            },
            value: {
                type: [Number, String],
                default: '',
            },
            currency: {
                type: String,
                default: 'RUB',
                required: false,
            },
        },
        computed: {
            currencyIcon() {
                return getCurrencyIcon(this.currency);
            },
            useCurrencyIcon() {
                return Boolean(this.currencyIcon && navigator.userAgent.indexOf('Windows NT 6.1') !== -1);
            },
        },
        methods: {
            format(value) {
                if (!value) {
                    return ' - ';
                }
                return this.useCurrencyIcon ?
                    value.toString().replaceAll(/[^\d\s\\.,]/g, '').trim() :
                    currencyAsString(value, this.currency);
            },
        },
    };
</script>